function arrayBufferToBase64(arrayBuffer: ArrayBuffer): string {
    let binary = '';

    const bytes = new Uint8Array(arrayBuffer);

    const binaryLen = bytes.byteLength;

    // Foreach Binary
    for (let i = 0; i < binaryLen; i++) {
        binary += String.fromCharCode(bytes[i]);
    }

    return window.btoa(binary);
}

// ----------------------------------------------------------------------------

export default arrayBufferToBase64;
